import axios from 'axios';
import {Api} from "./Func";
import moment from 'moment';
const CancelToken = axios.CancelToken;
let fetchs = {
    flag:0
};
//生成唯一标识符
const getUuid = () => {
    let d = new Date().getTime();
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        let r = (d + Math.random()*16)%16 | 0;
        d = Math.floor(d/16);
        return (c==='x' ? r : (r&0x3|0x8)).toString(16);
    });
    //return uuid;
};

const rmEmptyParam = (opt) => {
    let obj = {};
    for(let p in opt){
        if(opt.hasOwnProperty(p) && opt[p] !== '' && opt[p] !== undefined){
            obj[p] = opt[p];
        }
    }
    return obj;
};


export default {
    install(Vue,options){
        Vue.prototype.$ajax = async function(type,url,params,selferr){
            let f = fetchs.flag ++;
            let option = {
                method: type,
                url: url,
                cancelToken: new CancelToken(function (cancel) {
                    fetchs['cancel'+f] = cancel;
                })
            };
            // let token = localStorage.getItem('token');
            // if(token){
            //     option.headers = {Accept:'application/json',Authorization:JSON.parse(token).token};
            // }
            let p=params?params:{};
            if(type === 'get'){
                option.params = p;
            }else{
                option.data = p;
            }
            try{
                let msg = await axios(option);
                if(msg.data.result !== 0){
                    if(!selferr){
                        this.$error(msg.data.msg);
                    }
                }
                delete(fetchs['cancel' + f]);
                return msg;
            }catch(error){
                this.$closeLoading();
                if('response' in error){
                    console.error(error.response);
                }
                let err = {data:{result:-1,msg:'网络错误',data:{}}};
                return err;
            }
        };
        //get
        Vue.prototype.$get = async function(url,params){
            let msg = await this.$ajax('get',url,params);
            if('data' in msg){
                if(msg.data == null){
                    msg.data = {};
                }
            }else{
                msg.data = {};
            }
            return msg.data;
        };
        //post
        Vue.prototype.$post = async function(url,params){
            let msg = await this.$ajax('post',url,params);
            return msg.data;
        };
        //get
        Vue.prototype.$myGet = async function(url,params){
            let msg = await this.$ajax('get',url,params,true);
            return msg.data;
        };
        //post
        Vue.prototype.$myPost = async function(url,params){
            let msg = await this.$ajax('post',url,params,true);
            return msg.data;
        };
        Vue.prototype.$error = function(msg){
            this.$message.error(msg?msg:'操作失败');
        };


        //中断所有请求
        Vue.prototype.$cancelAjax = function(){
            this.$closeLoading();
            for(let x in fetchs){
                if(x !== 'flag' && fetchs.hasOwnProperty(x)){
                    fetchs[x]();
                }
            }
        };


        Vue.prototype.$showLoading = function(){
            var html = [];
            html.push('<div class="loading" id="lxloading">');
            html.push('<div class="loading-area"></div>');
            html.push('</div>');
            let fragment=document.createDocumentFragment();
            let tempNode=document.createElement("div");
            tempNode.innerHTML=html.join('');
            let childNodes=tempNode.childNodes;
            for(let i=0;i<childNodes.length;i++){
                fragment.appendChild(childNodes[i].cloneNode(true));
            }
            document.body.appendChild(fragment);
            fragment = null;
            let load = document.getElementById("lxloading");
            setTimeout(()=>{
                load.style.opacity = 1;
            },10);
        };
        Vue.prototype.$closeLoading = function(){
            let load = document.getElementById("lxloading");
            let $loading = jQuery('.loading');
            if(load){
                load.style.opacity = 0;
                setTimeout(()=>{
                    let load2 = document.getElementById("lxloading");
                    if(load2) document.body.removeChild(load2);
                    $loading.remove();
                },200);
            }
        };

        Vue.prototype.$getUuid = function(){
            return getUuid();
        };

        //性别代码转文字
        Vue.prototype.$getGender = function(num){
            let s = ['未知','男','女'];
            let i = num!==undefined?num:0;
            return s[i];
        };
        //用户状态代码转文字
        Vue.prototype.$getUserStatus = function(num){
            let n = '' + num;
            let s = {
                '0':'未激活',
                '1':'正常',
                '2':'禁用',
                '4':'删除'
            };
            return s[''+num]?s[''+num]:num;
        };
        //时间转换
        Vue.prototype.$toLocalTime = function(num){
            return moment.unix(num).format('YYYY-MM-DD HH:mm:ss');
        };

        //延时执行
        Vue.prototype.$delay = function(cb,time){
            setTimeout(()=>{
                if(typeof(cb) === 'function') cb();
            },time?time:500);
        };

        //学校性质转换
        Vue.prototype.$getSchoolMode = function(num){
            const mode = {
                '1':'幼儿园',
                '2':'小学',
                '4':'初中',
                '8':'职高',
                '16':'高中',
                '32':'大学'
            };
            return mode[''+num];
        };

        //验证手机号
        Vue.prototype.$chkPhone = function(phone){
            let preg=/^1\d{10}$/;
            return preg.test(phone);
        };

        Vue.prototype.$getHost = function(){
            return window.location.host.match('ljlx.com')?'ljlx.com':'lejiaolexue.com';
        };

        //post下载文件
        Vue.prototype.$postDownload = function(url,p,filename,fn){
            let that = this;
            let param = [];
            for(let x in p){
                param.push(x + '=' + p[x]);
            }
            const xhr = new XMLHttpRequest();
            this.$showLoading();
            xhr.open('POST', url, true);
            xhr.setRequestHeader("Content-type","application/x-www-form-urlencoded");
            xhr.responseType = "blob";    // 返回类型blob
            // 定义请求完成的处理函数，请求前也可以增加加载框/禁用下载按钮逻辑
            xhr.onload = function () {
                that.$closeLoading();
                // 请求完成
                if (this.status === 200) {
                    // 返回200
                    let blob = this.response;
                    let reader = new FileReader();
                    reader.readAsDataURL(blob);    // 转换为base64，可以直接放入a表href
                    reader.onload = function (e) {
                        // 转换完成，创建一个a标签用于下载
                        let a = document.createElement('a');
                        a.download = filename + '.xls';
                        a.href = e.target.result;
                        $("body").append(a);    // 修复firefox中无法触发click
                        a.click();
                        $(a).remove();
                    }
                }

                if(typeof(fn)==='function'){
                    fn();
                }
            };
            // 发送ajax请求
            xhr.send(param.join('&'));
        };
        //获取用户信息by id
        Vue.prototype.GetUserInfoById = async function(user_id){
            let res = await this.$get('/api/user/getuserinfobyid', {user_id });
            return res.data;
        };
        //获取用户信息by loginname
        Vue.prototype.GetUserInfoByLogin = async function(login_name){
            let res = await this.$get('/api/user/getuserinfobylogin', {login_name});
            return res.data;
        };
        //获取用户菜单
        Vue.prototype.GetMenus = async function(){
            let res = await this.$get('/api/leftmenu/getmenus', {});
            return res;
        };
        //获取指定教育局的信息
        Vue.prototype.GetBureau = async function(id){
            let res = await this.$get('/api/bureau/getbureau', {bureau_id:id});
            return res;
        };
        //获取用户所在教育局自己的信息
        Vue.prototype.GetUserBureau = async function(){
            let res = await this.$get('/api/bureau/getuserbureau', {});
            return res;
        };
        //获取指定教育局的成员
        Vue.prototype.GetMemberList = async function({bureau_id,page_index,page_size}){
            let res = await this.$get('/api/bureau/getmemberlist', {bureau_id,page_index,page_size});
            return res;
        };
        //获取指定教育局辖区学校列表
        Vue.prototype.GetSchool = async function({bureau_id,page_index,page_size}){
            let res = await this.$get('/api/bureau/getschool', {bureau_id,page_index,page_size});
            return res;
        };

        //获取下级教育局
        Vue.prototype.GetSubBureau = async function(bureau_id){
            let res = await this.$get('/api/bureau/getsubbureau', {bureau_id});
            return res;
        };

        //获取指定地区全称
        Vue.prototype.GetAreaName = async function(areaid,iswhole){
            let res = await this.$get('/api/area/getareaname', {areaid,iswhole});
            return res;
        };
        //获取所在学校的信息
        Vue.prototype.GetUserSchool = async function(){
            let res = await this.$get('/api/school/getuserschool');
            return res;
        };
        //获取班级列表
        Vue.prototype.GetUserClass = async function(areaid,iswhole){
            let res = await this.$get('/api/class/getuserclass', {areaid,iswhole});
            return res;
        };
        //获取班级老师列表
        Vue.prototype.GetTeacherList = async function(class_id){
            let res = await this.$get('/api/class/getteacherlist', {class_id});
            return res;
        };
        //删除班级内老师
        Vue.prototype.DelTeacher = async function(class_id,user_id){
            let res = await this.$get('/api/class/delteacher', {class_id,user_id});
            return res;
        };
        //班主任设置班级管理员
        Vue.prototype.SetManager = async function(class_id,user_id){
            let res = await this.$get('/api/class/setmanager', {class_id,user_id});
            return res;
        };
        //班主任撤消班级管理员
        Vue.prototype.CancelManager = async function(class_id,user_id){
            let res = await this.$get('/api/class/cancelmanager', {class_id,user_id});
            return res;
        };
        //班主任给别人设置成班主任
        Vue.prototype.SetMaster = async function(class_id,user_id){
            let res = await this.$get('/api/class/setmaster', {class_id,user_id});
            return res;
        };
        //获取当前登录者在指定班级内的权限
        Vue.prototype.GetClsPowerLevel = async function(class_id){
            let res = await this.$get('/api/class/getclspowerlevel', {class_id});
            return res;
        };

        //获取班级学生列表
        Vue.prototype.GetStudentsInfo = async function(class_id,seekType=1){
            let res = await this.$get('/api/class/getstudentsinfo', {class_id,seekType});
            return res;
        };
        //学生重置密码
        Vue.prototype.ResetPassword = async function(class_id,user_id){
            let res = await this.$get('/api/class/resetpassword', {class_id,user_id});
            return res;
        };
        //修改学生姓名
        Vue.prototype.SetUserName = async function({class_id,user_id,name}){
            let res = await this.$get('/api/class/setusername', {class_id,user_id,name});
            return res;
        };
        //修改学生学籍号
        Vue.prototype.SetStudentCode = async function({class_id,user_id,stucode}){
            let res = await this.$get('/api/class/setstudentcode', {class_id,user_id,stucode});
            return res;
        };
        //修改学生学号
        Vue.prototype.SetStudentNo = async function({class_id,user_id,stuno}){
            let res = await this.$get('/api/class/setstudentno', {class_id,user_id,stuno});
            return res;
        };
        //修改学生性别
        Vue.prototype.SetUserGender = async function({class_id,user_id,gender}){
            let res = await this.$get('/api/class/setusergender', {class_id,user_id,gender});
            return res;
        };
        //删除学生
        Vue.prototype.DelStudent = async function(class_id,user_id){
            let res = await this.$get('/api/class/delstudent', {class_id,user_id});
            return res;
        };
        //解绑家长
        Vue.prototype.UnbindChild = async function({class_id,student_id,parent_id}){
            let res = await this.$get('/api/class/unbindchild', {class_id,student_id,parent_id});
            return res;
        };
        //绑定家长
        Vue.prototype.ChildBindParent = async function({class_id,student_id,phone,relation}){
            let res = await this.$get('/api/class/childbindparent', {class_id,student_id,phone,relation});
            return res;
        };

        //修改学校名称
        Vue.prototype.SetSchoolName = async function(school_id,name){
            let res = await this.$get('/api/school/setschoolname', {school_id,name});
            return res;
        };
        //获取中心校的分校
        Vue.prototype.GetBranchSchool = async function(school_id){
            let res = await this.$get('/api/school/getbranchschool', {school_id});
            return res;
        };
        //中心校解除分校
        Vue.prototype.UnbindBranchSchool = async function(school_id,branch_school_id){
            let res = await this.$get('/api/school/unbindbranchschool', {school_id,branch_school_id});
            return res;
        };
        //分校加入中心校
        Vue.prototype.BindCenterSchool = async function(center_school_id,school_id){
            let res = await this.$get('/api/school/bindcenterschool', {center_school_id,school_id});
            return res;
        };
        //获取指定id的学校信息
        Vue.prototype.GetSchoolInfo = async function(school_id){
            let res = await this.$get('/api/school/getschoolinfo', {school_id});
            return res;
        };
        //搜索学校
        Vue.prototype.SeekSchool = async function({area_id,page_index,page_size,name}){
            let res = await this.$get('/api/school/seekschool', {area_id,page_index,page_size,name});
            return res;
        };
        //获取学校成员列表
        Vue.prototype.GetSchoolMemberList = async function({school_id,find_name,page_index,page_size}){
            let res = await this.$get('/api/school/getmemberlist', {school_id,find_name,page_index,page_size});
            return res;
        };
        //学校删除成员
        Vue.prototype.DelSchoolMember = async function(school_id,user_id){
            let res = await this.$get('/api/school/delmember', {school_id,user_id});
            return res;
        };
        //向学校添加成员
        Vue.prototype.AddSchoolMember = async function(school_id,user_id){
            let res = await this.$myGet('/api/school/addmember', {school_id,user_id});
            return res;
        };
        //修改成员角色
        Vue.prototype.SetMemberRole = async function({school_id,user_id,role}){
            let res = await this.$get('/api/school/setmemberrole', {school_id,user_id,role});
            return res;
        };

        //获取所有年级
        Vue.prototype.GetSchoolGrades = async function(school_id){
            let res = await this.$get('/api/school/getschoolgrades', {school_id});
            return res;
        };
        //获取指定年级的班级
        Vue.prototype.GetClassList = async function(school_id,grade_id){
            let res = await this.$get('/api/school/getclasslist', {school_id,grade_id});
            return res;
        };
        //获取指定班级的信息
        Vue.prototype.GetSchoolClassInfo = async function(class_id){
            let res = await this.$get('/api/school/getclass', {class_id});
            return res;
        };
        //设置班号
        Vue.prototype.SetClassNO = async function({school_id,class_id,class_no}){
            let res = await this.$get('/api/school/setclassno',{school_id,class_id,class_no});
            return res;
        };
        //创建班级
        Vue.prototype.CreateClass = async function({school_id,grade_id,class_name='',class_no=0}){
            let res = await this.$get('/api/school/createclass',{school_id,grade_id,class_name,class_no});
            return res;
        };
        //普通注销班级
        Vue.prototype.DelClassFromSchool = async function(school_id,class_id){
            let res = await this.$get('/api/school/delclass',{school_id,class_id});
            return res;
        };
        //设置班级名称
        Vue.prototype.SetClassName = async function({school_id,class_id,class_name}){
            let res = await this.$get('/api/school/setclassname',{school_id,class_id,class_name});
            return res;
        };
        //设置班级的年级
        Vue.prototype.SetClassGrade = async function({school_id,class_id,grade_id}){
            let res = await this.$get('/api/school/setclassgrade',{school_id,class_id,grade_id});
            return res;
        };
        //获取班级老师列表
        Vue.prototype.GetTeacherListForClass = async function(school_id,class_id){
            let res = await this.$myGet('/api/school/getteacherlist', {school_id,class_id});
            return res;
        };
        //取消指定班级的班主任
        Vue.prototype.CancelMasterForClass = async function(school_id,class_id){
            let res = await this.$get('/api/school/cancelmaster',{school_id,class_id});
            return res;
        };
        //设置指定班级的班主任
        Vue.prototype.SetMasterForClass = async function({school_id,class_id,user_id}){
            let res = await this.$get('/api/school/setmaster',{school_id,class_id,user_id});
            return res;
        };
        //删除指定班级的老师
        Vue.prototype.DelTeacherFromClass = async function({school_id,class_id,user_id}){
            let res = await this.$myGet('/api/school/delteacher',{school_id,class_id,user_id});
            return res;
        };
        //取消指定班级的管理员
        Vue.prototype.CancelManagerForClass = async function({school_id,class_id,user_id}){
            let res = await this.$get('/api/school/cancelmanager',{school_id,class_id,user_id});
            return res;
        };
        //设置指定班级的管理员
        Vue.prototype.SetManagerForClass = async function({school_id,class_id,user_id}){
            let res = await this.$get('/api/school/setmanager',{school_id,class_id,user_id});
            return res;
        };
        //获取指定班级学生列表
        Vue.prototype.GetStudentListForClass = async function(school_id,class_id){
            let res = await this.$get('/api/school/getstudentsinfo', {school_id,class_id});
            return res;
        };
        //向班级添加老师
        Vue.prototype.AddTeacherToClass = async function({school_id,class_id,user_id}){
            let res = await this.$myGet('/api/school/addteacher',{school_id,class_id,user_id});
            return res;
        };
        //老师批量调班
        Vue.prototype.TransferClassTeachers = async function({school_id,class_id,target_class_id,user_ids}){
            let res = await this.$myGet('/api/school/transferclassteachers',{school_id,class_id,target_class_id,user_ids});
            return res;
        };
        //批量删除指定班级的学生
         Vue.prototype.ClsDelStudents = async function({school_id,class_id,user_ids}){
            let res = await this.$myGet('/api/school/clsdelstudents',{school_id,class_id,user_ids});
            return res;
        };
        //批量调学生到其他班
        Vue.prototype.TransferClassStudent = async function({school_id,class_id,target_class_id,user_ids}){
            let res = await this.$get('/api/school/transferclassstudent',{school_id,class_id,target_class_id,user_ids});
            return res;
        };
        //向班级内导入学生
        Vue.prototype.ClsImportStudent = async function({school_id,class_id,stu_name,gender,code,stu_number,father_phone,month_phone,oth_phone}){
            let p = rmEmptyParam({school_id,class_id,stu_name,gender,code,stu_number,father_phone,month_phone,oth_phone});
            let res = await this.$myGet('/api/school/clsimportstudent',p);
            return res;
        };
        //向学校导入老师
        Vue.prototype.SchImportTeacher = async function({school_id,teacher_name,gender,duty,phone_no}){
            let res = await this.$myGet('/api/school/schimportteacher',{school_id,teacher_name,gender,duty,phone_no});
            return res;
        };
        //向学校导入班主任
        Vue.prototype.SchImportClass = async function({school_id,grade_name,cls_name,phone_no}){
            let res = await this.$myGet('/api/school/schimportclass',{school_id,grade_name,cls_name,phone_no});
            return res;
        };
        //向学校导入学生
        Vue.prototype.SchoolStudentImport = async function({schoolid,gradeid,classno,name,gender,stucode,stuno,parents}){
            let res = await this.$myPost('/api/school/importstudentbyschool',{schoolid,gradeid,classno,name,gender,stucode,stuno,parents});
            return res;
        };
    }
}


// WEBPACK FOOTER //
// ./src/common/Public.js